const VERSION_STATUS: boolean = window.location.hostname.search('localhost') === -1;
const BETA_VERSION: boolean = window.location.hostname.search('beta') === -1;
const ARK_VERSION: boolean = window.location.hostname.search('4rk') === -1;
const MOBILE_VERSION: boolean = window.location.hostname.search('192.168.1.85') === -1;

// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = VERSION_STATUS ? 'https://panel.mahi20.4rk.ir/' : 'http://localhost/sanam/';
// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
export const IMAGE_ADDRESS = 'https://koochi.4rk.ir/';
export const BASE_SITE = 'https://api.koochi.4rk.ir/';
// const BASE_API = VERSION_STATUS ? 'api/v1/' : 'api/beta/';
const BASE_API = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'v1/' : 'v1/';


export const INITIAL_DATA_GET = BASE_API + 'initial-data'; //Authorization
export const LOGIN = BASE_API + 'users/login'; //mobile
export const USERS_ACTIVATION_POST = BASE_API + 'users/activation'; //code,mobile
export const USERS_CHECK_LOGIN_GET = BASE_API + 'users/check-login'; //Authorization
export const USERS_EDIT_PERSONAL_INFO_POST = BASE_API + 'users/edit-personal-info'; //Authorization | fname, lname, national_code, birth_day, birth_month, birth_year
export const USERS_EDIT_EMAIL = BASE_API + 'users/edit-email'; //Authorization | email
export const USERS_EDIT_MOBILE_SEND_OTP_1_POST = BASE_API + 'users/edit-mobile-send-otp-1'; //Authorization | mobile
export const USERS_EDIT_MOBILE_SEND_OTP_2_POST = BASE_API + 'users/edit-mobile-send-otp-2'; //Authorization | code
export const USERS_EDIT_MOBILE_FINAL_POST = BASE_API + 'users/edit-mobile-final'; //Authorization | code
export const USERS_LOGOUT_GET = BASE_API + 'users/logout'; //Authorization
export const USERS_ADD_ADDRESS_POST = BASE_API + 'add-address'; //Authorization | city, address, plate, unit, postalCode
export const USERS_ADDRESSES_GET = BASE_API + 'addresses'; //Authorization 
export const PRODUCTS_GET = BASE_API + 'category/'; //Authorization
export const SELLER_PRODUCTS_GET = BASE_API + 'seller-products/'; //Authorization
export const PRODUCT_DETAILS_POST = BASE_API + 'product/details'; //product
export const CHECKOUT_SHIPPING_POST = BASE_API + 'checkout/shipping'; //product
export const PROVINCES_GET = BASE_API + 'initial-data/provinces'; 
export const CITIES_POST = BASE_API + 'initial-data/cities'; 
export const MAIN_POST = BASE_API + 'main'; // width
export const CHECKOUT_REGISTER_ORDER_POST = BASE_API + 'checkout/register'; // Authorization | 
export const ORDERS_HISTORY = BASE_API + 'profile/orders'; // Authorization | 
export const PRODUCT_RATING = BASE_API + 'orders/product-rating'; // Authorization | uniqueCode, slug, rate
export const SEARCH_SUGGESTION_GET = BASE_API + 'search/suggestion'; // Authorization | q
export const SEARCH_GET = BASE_API + 'search'; // Authorization | q
export const BEST_SELLING = BASE_API + 'best-selling'; // Authorization | q
export const AMAZING_OFFERS = BASE_API + 'amazing-offers'; // Authorization |
export const FLASH_SALE = BASE_API + 'flash-sale'; // Authorization |


